import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { RoundListFilter } from './components/round-list-filter';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { RoundListTable } from './components/round-list-table';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Fragment } from 'react/jsx-runtime';
import { useRoundsListQuery } from '../queries';
import { querySchema } from './query-schema';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = useRoundsListQuery({
    page_size: values.pageSize,
    ordering: values.ordering,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Serieomgångar" />
        <PageLayout.Context items={[<ContextMenu.Item label="Skapa serieomgång" to="create" key="create" />]} />
      </PageLayout.Header>

      <PageLayout.Section>
        <RoundListFilter />
        <RoundListTable rounds={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
